import React, { memo } from 'react'

import { Button, Icon, InfoOutlined } from '@cgtrader/triangle-ui/dist/src/ssr-index'
import {
  bool, elementType, func, string,
} from 'prop-types'

import DesktopOnlyTooltip from 'Pods/Shared/DesktopOnlyTooltip/DesktopOnlyTooltip'
import { iconSize } from 'Pods/ThreeDStudio/constants'

const infoIconSize = { height: '14px', width: '14px' }

function TabButton({
  id,
  label,
  icon,
  onClick: handleClick,
  isActive,
  tooltip = undefined,
}) {
  const button = (
    <Button
      type="secondary"
      variant="with-icon"
      size="tiny"
      customClass="action-selector__tabs-button"
      expand
      onClick={handleClick}
      isActive={isActive}
    >
      <Icon svgComponent={icon} color="darker" size={iconSize} notSpaced />
      {label}
      {tooltip && <Icon svgComponent={InfoOutlined} color="darker" size={infoIconSize} notSpaced />}
    </Button>
  )

  if (!tooltip) {
    return button
  }

  // The tooltip wrapper spans take the tab's place in the flex row, so they carry
  // the sizing class that keeps the three tabs sharing the row equally.
  return (
    <DesktopOnlyTooltip
      id={`${id}-tab`}
      content={tooltip}
      place="top"
      containerClass="action-selector__tabs-item"
      className="action-selector__tabs-item"
      tooltipClassName="action-selector__tooltip"
      focusWithin
    >
      {button}
    </DesktopOnlyTooltip>
  )
}

TabButton.propTypes = {
  id: string.isRequired,
  label: string.isRequired,
  icon: elementType.isRequired,
  onClick: func.isRequired,
  isActive: bool.isRequired,
  tooltip: string,
}

export default memo(TabButton)
